import {
  PersonCard,
  type PersonCardSocialType,
} from '@rouvydev/web-components/content'
import { Link } from 'react-router'
import {
  type Enum_Componentsharedsocialplatform_Type,
  type AuthorFragment,
  type AuthorsByTypeFragment,
} from '~/model/api.ts'

export function preparePersonCardsProps(data: AuthorsByTypeFragment) {
  return {
    authors: data.authorsByType.filter(Boolean),
  }
}

type Props = {
  authors: AuthorFragment[]
}

function mapSocialType(
  type: Enum_Componentsharedsocialplatform_Type | undefined,
): PersonCardSocialType {
  switch (type?.toLowerCase()) {
    case 'strava':
      return 'strava'
    case 'whatsapp':
      return 'whatsapp'
    case 'youtube':
      return 'youtube'
    case 'facebook':
      return 'fb'
    case 'instagram':
      return 'instagram'
    case 'linkedin':
      return 'linkedin'
    case 'twitter':
    case 'x':
      return 'x'
    case 'rouvy':
      return 'rouvy'
    default:
      return 'other'
  }
}

export function PersonCards(props: Props) {
  const { authors } = props
  return (
    <div className="container mx-auto py-20 md:py-10">
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {authors.map((author) => {
          return (
            <PersonCard
              key={author.id}
              name={author.name}
              role={author.jobTitle ?? ''}
              bio={author.perex ?? ''}
              link={<Link to={`/blog/author/${author.slug}`} />}
              imageUrl={author.profilePhoto?.data[0]?.attributes?.url}
              socialLinks={
                author.socialPlatform?.map((platform) => ({
                  type: mapSocialType(platform?.type),
                  url: platform?.link ?? '',
                })) ?? []
              }
            />
          )
        })}
      </div>
    </div>
  )
}
